export default __webpack_public_path__ + "static/pragicts-ai-banner-decision-making-a132b044df67e2844d7aaa915b6f724c.jpg";